export const BEHAVIORS = 'behaviors'
